import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'logo',
    label: i18n('entities.producer.fields.logo'),
    schema: schemas.images(
      i18n('entities.producer.fields.logo'),
      {},
    ),
  },
  {
    name: 'name',
    label: i18n('entities.producer.fields.name'),
    schema: schemas.string(
      i18n('entities.producer.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'info',
    label: i18n('entities.producer.fields.info'),
    schema: schemas.string(
      i18n('entities.producer.fields.info'),
      {},
    ),
  },
];